import { render, staticRenderFns } from "./CollectionRecordDetailsTable.vue?vue&type=template&id=11bde0c2&scoped=true"
import script from "./CollectionRecordDetailsTable.vue?vue&type=script&lang=js"
export * from "./CollectionRecordDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordDetailsTable.vue?vue&type=style&index=0&id=11bde0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bde0c2",
  null
  
)

export default component.exports